import { render, staticRenderFns } from "./RedPillStudio.vue?vue&type=template&id=224a27cb"
import script from "./RedPillStudio.vue?vue&type=script&lang=js"
export * from "./RedPillStudio.vue?vue&type=script&lang=js"
import style0 from "./RedPillStudio.vue?vue&type=style&index=0&id=224a27cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports